/* Nanocoating.nl — Blog-zijbalk: plaatsing naast/onder het artikel, verwante artikelen en reserve voor "Nieuwste". */
(function () {
  'use strict';
  var STOP = ('de het een en of voor van met op in te je jouw uw hoe wat welke waarom waar kan kun naar over als dan ook dit dat die deze zijn worden wordt je ' +
    'bij uit aan door om tot niet geen meer meest alle tips tip nano nanocoating nanocoatings coating coatings ' +
    'veilig effectief complete gids makkelijk eenvoudig simpel snel beste goede stap stappen stappenplan').split(' ');
  /* algemene werkwoorden: leveren veel (weinig specifieke) resultaten op, dus pas als laatste zoeken */
  var GENERIC = 'verwijderen schoonmaken reinigen maken beschermen behandelen impregneren krijgen houden voorkomen'.split(' ');
  var LIMIT = 10;

  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim(); }
  function stem(w) { return w.length > 6 ? w.slice(0, 6) : w; }
  function words(s) {
    var out = [], seen = {};
    norm(s).split(' ').forEach(function (w) {
      if (w.length < 4 || STOP.indexOf(w) > -1 || seen[w]) return;
      seen[w] = 1; out.push(w);
    });
    return out;
  }
  /* alleen het pad: zonder domein, zonder ?_pos=…&_psq=… (die voegt de zoekfunctie van Shopify toe) en zonder slot-slash */
  function path(u) { return String(u || '').replace(/^([a-z][a-z0-9+.-]*:)?\/\/[^\/]+/i, '').replace(/[?#].*$/, '').replace(/\/+$/, ''); }
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

  function track(el, ev, data) {
    if (el.dataset.tracking !== 'true') return;
    window.dataLayer = window.dataLayer || [];
    data.event = ev; window.dataLayer.push(data);
  }

  /* ---------- Plaatsing ---------- */
  function findArticle(el) {
    var custom = el.dataset.articleSelector;
    var list = (custom ? [custom] : []).concat(['article.article-template', '.article-template', 'main article', '[itemtype*="Article"]', 'article']);
    for (var i = 0; i < list.length; i++) {
      var found;
      try { found = document.querySelector(list[i]); } catch (e) { found = null; }
      if (found && !el.contains(found)) return found;
    }
    return null;
  }
  function place(el) {
    if (el.closest('.nce-side-layout')) return;
    var art = findArticle(el);
    var layout = el.dataset.layout === 'onder' ? 'onder' : 'naast';
    if (!art) return;
    /* Het artikel zit meestal in een eigen thema-sectie; die verplaatsen we samen met de zijbalk in een raster */
    var sec = art.closest('.shopify-section') || art;
    var host = sec.parentElement;
    var rootSec = el.closest('.shopify-section') || el;
    if (!host || rootSec === sec) return;
    var wrap = document.createElement('div');
    wrap.className = 'nce-side-layout';
    wrap.setAttribute('data-nce-layout', layout);
    host.insertBefore(wrap, sec);
    wrap.appendChild(sec);
    wrap.appendChild(el);
    if (rootSec !== el && !rootSec.children.length) rootSec.style.display = 'none';
  }

  /* ---------- Verwante artikelen ---------- */
  function suggest(q) {
    var url = root() + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=article&resources[limit]=' + LIMIT;
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { return (j && j.resources && j.resources.results && j.resources.results.articles) || []; })
      .catch(function () { return []; });
  }
  function related(el) {
    var box = el.querySelector('[data-nce-side-related]');
    if (!box || !window.fetch) return;
    var max = parseInt(el.dataset.relatedMax, 10) || 5;
    var title = el.dataset.title || '';
    var tags = (el.dataset.tags || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean).slice(0, 2);
    var cur = path(el.dataset.url);
    var tw = words(title), tws = tw.map(stem);
    if (!tw.length && !tags.length) return;

    /* De zoekfunctie van Shopify vraagt dat ALLE zoekwoorden voorkomen. Daarom zoeken we met losse woorden:
       eerst de onderwerpwoorden uit de titel, daarna de algemene werkwoorden (verwijderen, schoonmaken…). */
    var specific = tw.filter(function (w) { return GENERIC.indexOf(w) < 0; });
    var generic = tw.filter(function (w) { return GENERIC.indexOf(w) > -1; });
    var queries = [];
    specific.concat(generic).slice(0, 4).concat(tags).forEach(function (q) { if (queries.indexOf(q) < 0) queries.push(q); });

    Promise.all(queries.map(function (q) { return suggest(q).then(function (list) { return { q: q, list: list, tag: tags.indexOf(q) > -1 }; }); })).then(function (res) {
      var map = {};
      res.forEach(function (r) {
        /* geeft een zoekwoord de maximale 10 treffers, dan is het algemeen en telt het minder zwaar */
        var weight = (r.tag || r.list.length < LIMIT) ? 3 : 1;
        r.list.forEach(function (a) {
          var p = path(a.url);
          if (!p || p === cur || p.indexOf('/blogs/') !== 0 || !a.title) return;
          var m = map[p] || (map[p] = { a: a, p: p, score: 0, overlap: 0 });
          m.score += weight;
        });
      });
      var out = Object.keys(map).map(function (p) {
        var m = map[p];
        words(m.a.title).map(stem).forEach(function (w) { if (tws.indexOf(w) > -1) m.overlap++; });
        m.score += m.overlap * 2;
        return m;
      }).filter(function (m) { return m.overlap > 0; }) /* alleen artikelen die echt een woord met de titel delen */
        .sort(function (x, y) { return y.score - x.score; }).slice(0, max);
      if (!out.length) return;
      var ul = box.querySelector('ul');
      ul.innerHTML = '';
      out.forEach(function (m, i) {
        var li = document.createElement('li'); li.className = 'nce-side__item';
        var a = document.createElement('a'); a.className = 'nce-side__link';
        a.href = m.p; a.textContent = m.a.title;
        a.setAttribute('data-nce-side-track', 'verwant'); a.setAttribute('data-nce-pos', String(i + 1));
        li.appendChild(a); ul.appendChild(li);
      });
      box.hidden = false;
    });
  }

  /* ---------- Nieuwste artikelen: reserve via de Atom-feed van de blog ---------- */
  function newest(el) {
    var box = el.querySelector('[data-nce-side-new]');
    if (!box || !window.fetch) return;
    var handle = el.dataset.blog;
    if (!handle) { var seg = path(el.dataset.url).split('/'); handle = seg[2] || ''; }
    if (!handle) return;
    var max = parseInt(el.dataset.newMax, 10) || 10, showDate = el.dataset.showDate === 'true', cur = path(el.dataset.url);
    fetch(root() + 'blogs/' + encodeURIComponent(handle) + '.atom', { headers: { Accept: 'application/atom+xml, application/xml, text/xml' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (txt) {
        if (!txt) return;
        var doc = new DOMParser().parseFromString(txt, 'application/xml');
        var entries = doc.getElementsByTagName('entry'), items = [], seen = {};
        for (var i = 0; i < entries.length && items.length < max; i++) {
          var e = entries[i], t = e.getElementsByTagName('title')[0], links = e.getElementsByTagName('link'), href = '';
          for (var k = 0; k < links.length; k++) { if (!href || links[k].getAttribute('rel') === 'alternate') href = links[k].getAttribute('href') || href; }
          var p = path(href);
          if (!t || !p || p === cur || seen[p] || p.indexOf('/blogs/') !== 0) continue;
          seen[p] = 1;
          var pub = e.getElementsByTagName('published')[0];
          items.push({ title: t.textContent.replace(/\s+/g, ' ').trim(), p: p, date: pub ? pub.textContent.slice(0, 10) : '' });
        }
        if (!items.length) return;
        var ul = box.querySelector('ul'); ul.innerHTML = '';
        items.forEach(function (it, i) {
          var li = document.createElement('li'); li.className = 'nce-side__item';
          var a = document.createElement('a'); a.className = 'nce-side__link'; a.href = it.p; a.textContent = it.title;
          a.setAttribute('data-nce-side-track', 'nieuwste'); a.setAttribute('data-nce-pos', String(i + 1));
          li.appendChild(a);
          if (showDate && /^\d{4}-\d{2}-\d{2}$/.test(it.date)) {
            var d = document.createElement('time'); d.className = 'nce-side__date'; d.setAttribute('datetime', it.date);
            d.textContent = it.date.slice(8, 10) + '-' + it.date.slice(5, 7) + '-' + it.date.slice(0, 4); li.appendChild(d);
          }
          ul.appendChild(li);
        });
        box.hidden = false;
      }).catch(function () {});
  }

  function init(el) {
    if (el.__nceSide) return; el.__nceSide = true;
    place(el);
    related(el);
    newest(el);
    el.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-nce-side-track]');
      if (!a) return;
      track(el, 'blog_sidebar_click', { sidebar_list: a.getAttribute('data-nce-side-track'), sidebar_position: a.getAttribute('data-nce-pos'), link_url: a.href });
    });
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-nce-side]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
